import script from "./RacePoints.vue?vue&type=script&setup=true&lang=ts"
export * from "./RacePoints.vue?vue&type=script&setup=true&lang=ts"

import "./RacePoints.vue?vue&type=style&index=0&id=47d0d8b4&lang=css"

const __exports__ = script;

export default __exports__